import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/typings/dialog';
import {JobModel} from '../../models/job.model';
import {MatDialog, MatDialogRef} from '@angular/material';


@Component({
  selector: 'app-apply-as-student',
  templateUrl: './apply-as-student.component.html',
  styleUrls: ['./apply-as-student.component.scss']
})
export class ApplyAsStudentComponent implements OnInit {
    loading: any;

  constructor(
      @Inject(MAT_DIALOG_DATA)
      public job: JobModel,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<ApplyAsStudentComponent>,
  ) { }

  ngOnInit(): void {

  }

  apply(): void {

  }

}
